import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const i18nNewParagraph = () => ({
    newParagraph: (_jsxs("span", { children: [_jsx("br", {}), _jsx("br", {})] })),
});
